import React from "react";
import {
  WordView,
  useCreateTagInstance,
  useGetAllUserTags,
  CreateTagInstanceRequest,
  CreateTagInstanceRequestSourceLocation,
} from "../api-generated";
import Header from "./Header";
import Loading from "./Loading";
import ErrorLoading from "./ErrorLoading";
import FuzzySearch from "./FuzzySearch";

interface Props {
  //TODO: why do I have to use this specific type here?
  //why isn't there a general one coming from openapi spec?
  wordLocation: CreateTagInstanceRequestSourceLocation;
  word: WordView;
  onSuccessfulTag: () => void;
  isForToken: boolean; // else is for whole line
}

const CreateTagInstanceForm: React.FC<Props> = ({
  word,
  onSuccessfulTag,
  wordLocation,
  isForToken,
}) => {
  const { data: tags, isLoading, error } = useGetAllUserTags();
  const tagInstanceMut = useCreateTagInstance();

  const createTagInstance = (tagId: number) => {
    const body: CreateTagInstanceRequest = {
      tagId,
      sourceLocation: {
        ...wordLocation,
        tokenIndex: isForToken ? wordLocation.tokenIndex : undefined,
      },
    };

    tagInstanceMut.mutate(
      {
        data: body,
      },
      {
        onSuccess: () => {
          onSuccessfulTag();
        },
      }
    );
  };

  return (
    <div>
      <Header
        type="main"
        text={
          isForToken
            ? `Add tag to instance of: "${word.displayString}"`
            : "Add tag to this line/sentence"
        }
      />
      {isLoading && <Loading />}
      {error && (
        <div>
          <ErrorLoading error={error} />
        </div>
      )}
      {!isLoading && !error && (
        <div className="pt-4">
          <FuzzySearch
            items={tags.map((t) => ({
              id: t.id,
              name: t.name,
            }))}
            onItemSelect={createTagInstance}
            noMatchingResultsMessage="No matching tags"
          />
        </div>
      )}
    </div>
  );
};

export default CreateTagInstanceForm;
